import {
  fetchSubsidizedStudentsTypes,
  approveStudentSubsidyTypes,
  rejectStudentSubsidyTypes,
  addSubsidyCreditsTypes,
  fetchStudentSubsidyTransactionsTypes,
  createSubsidyTypes,
  addSubsidyStudentsTypes,
  removeSubsidyStudentsTypes,
  distributeSubsidyCreditsTypes,
  studentSubsidyApproveTypes,
  studentSubsidyRejectTypes,
  adminAddCardTypes,
  subsidyCreditsPurchaseTypes,
  adminChangeDefaultCardTypes,
  editSubsidyTypes,
  CLEAR_PAYMENT_STATUS,
  SUBSCRIBE_TO_SUBSIDY,
} from './action_types';

import {
  FETCH_SUBSIDIZED_STUDENTS_QUERY,
  APPROVE_STUDENT_SUBSIDY_MUTATION,
  REJECT_STUDENT_SUBSIDY_MUTATION,
  ADD_SUBSIDY_CREDITS_MUTATION,
  ADD_SUBSIDY_STUDENTS_MUTATION,
  FETCH_STUDENT_SUBSIDY_TRANSACTIONS_QUERY,
  CREATE_SUBSIDY_MUTATION,
  REMOVE_SUBSIDY_STUDENTS_MUTATION,
  DISTRIBUTE_SUBSIDY_CREDITS_MUTATION,
  STUDENT_SUBSIDY_APPROVE_MUTATION,
  STUDENT_SUBSIDY_REJECT_MUTATION,
  ADMIN_ADD_CARD_MUTATION,
  SUBSIDY_CREDITS_PURCHASE_MUTATION,
  ADMIN_CHANGE_DEFAULT_CARD_MUTATION,
  EDIT_SUBSIDY_MUTATION,
  SUBSCRIBE_TO_SUBSIDY_SUBSCRIPTION,
} from './api';

import { makeSubscription, makeQuery, makeMutation } from '../../config/client';

export const fetchSubsidizedStudents = vars => makeQuery(vars)(
  fetchSubsidizedStudentsTypes,
  FETCH_SUBSIDIZED_STUDENTS_QUERY
);

export const adminChangeDefaultCard = variables => makeMutation({ variables })(
  adminChangeDefaultCardTypes,
  ADMIN_CHANGE_DEFAULT_CARD_MUTATION
);

export const subsidyCreditsPurchase = variables => makeMutation({ variables })(
  subsidyCreditsPurchaseTypes,
  SUBSIDY_CREDITS_PURCHASE_MUTATION
);

export const adminAddCard = variables => makeMutation({ variables })(
  adminAddCardTypes,
  ADMIN_ADD_CARD_MUTATION
);

export const approveStudentSubsidy = variables => makeMutation({ variables })(
  approveStudentSubsidyTypes,
  APPROVE_STUDENT_SUBSIDY_MUTATION
);

export const distributeSubsidyCredits = variables => makeMutation({ variables })(
  distributeSubsidyCreditsTypes,
  DISTRIBUTE_SUBSIDY_CREDITS_MUTATION
);

export const rejectStudentSubsidy = variables => makeMutation({ variables })(
  rejectStudentSubsidyTypes,
  REJECT_STUDENT_SUBSIDY_MUTATION
);

export const createSubsidy = variables => makeMutation({ variables })(
  createSubsidyTypes,
  CREATE_SUBSIDY_MUTATION
);

export const editSubsidy = variables => makeMutation({ variables })(
  editSubsidyTypes,
  EDIT_SUBSIDY_MUTATION
);

export const addSubsidyStudents = variables => makeMutation({ variables })(
  addSubsidyStudentsTypes,
  ADD_SUBSIDY_STUDENTS_MUTATION
);

export const studentSubsidyApprove = variables => makeMutation({ variables })(
  studentSubsidyApproveTypes,
  STUDENT_SUBSIDY_APPROVE_MUTATION
);

export const studentSubsidyReject = variables => makeMutation({ variables })(
  studentSubsidyRejectTypes,
  STUDENT_SUBSIDY_REJECT_MUTATION
);

export const removeSubsidyStudents = variables => makeMutation({ variables })(
  removeSubsidyStudentsTypes,
  REMOVE_SUBSIDY_STUDENTS_MUTATION
);

export const addSubsidyCredits = variables => makeMutation({ variables })(
  addSubsidyCreditsTypes,
  ADD_SUBSIDY_CREDITS_MUTATION
);

export const fetchStudentSubsidyTransactions = vars => makeQuery(vars)(
  fetchStudentSubsidyTransactionsTypes,
  FETCH_STUDENT_SUBSIDY_TRANSACTIONS_QUERY
);

export const clearPaymentStatus = () => ({ type: CLEAR_PAYMENT_STATUS });

export const subscribeToSubsidy = variables => makeSubscription({
  variables,
  name: 'subsidyAdded',
})(
  SUBSCRIBE_TO_SUBSIDY,
  SUBSCRIBE_TO_SUBSIDY_SUBSCRIPTION
);



// WEBPACK FOOTER //
// ./src/modules/subsidy/actions.js